module.exports = __webpack_public_path__ + "static/og_image-8410b07d1b97a24d74545f890f759b71.jpg";